import { UrlService, HeadersServices } from 'services';
export function GetSpreadSheetService({ filter, url }) {
  const axios = require('axios');
  const FileDownload = require('js-file-download');

  let endpoint = url ? url : filter ? `dashboard/export?startDate=${filter?.start}&endDate=${filter?.end}` : 'dashboard/export';

  axios({
    method: 'GET',
    url: UrlService() + endpoint,
    responseType: 'arraybuffer',
    headers: HeadersServices()
  })
    .then(function (response) {
      const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const match = regex.exec(response.headers["content-disposition"]);
      let fileName = match[1];
      fileName = fileName.replace(/"/g, "");
      FileDownload(response.data, fileName);
    });
}
